<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header text-center">
          <i class="fas fas-align-justify"></i>
          Current Deals
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-4">
              <img class="img-fluid"
                src="https://fitritestagingstorage.blob.core.windows.net/fitrite365/websitecontent/offers/offer1_watermark.png">
            </div>
            <div class="col-12 col-md-4">
              <img class="img-fluid"
                src="https://fitritestagingstorage.blob.core.windows.net/fitrite365/websitecontent/offers/offer2_watermark.png">
            </div>
            <div class="col-12 col-md-4">
              <img class="img-fluid"
                   src="https://fitritestagingstorage.blob.core.windows.net/fitrite365/websitecontent/offers/offer3_watermark.png">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

